const clientToken = import.meta.env['VITE_PAYMENTS_CLIENT_TOKEN'];

export function PaymentTestModeBanner() {
  if (!clientToken) {
    return (
      <div className="w-full border-b border-destructive/40 bg-destructive/15 px-4 py-2 text-center text-sm text-destructive">
        Production checkout is not configured yet.
      </div>
    );
  }
  if (clientToken.startsWith("pk_test_")) {
    return (
      <div className="w-full border-b border-primary/40 bg-primary/10 px-4 py-2 text-center text-sm text-primary">
        Todos los pagos en la vista previa son de prueba / All payments in preview are in test mode.
      </div>
    );
  }
  return null;
}
